import { MutationHookOptions, gql, useMutation } from '@apollo/client'

import { GraphqlClientType } from '@/config/apollo'
import { Notification } from '@/graphql/appsync-notifications'
import { Maybe, Scalars } from '@/graphql/generated/schemas'

export type UpdateNotificationInput = {
  notificationTimestamp: Scalars['String']
  read: Scalars['Boolean']
}

export type UpdateNotificationVariables = {
  input: UpdateNotificationInput
}

export type UpdateNotificationMutation = {
  __typename?: 'Mutation'
  updateNotification?: Maybe<Notification>
}

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      notificationTimestamp
      read
    }
  }
`

export const useUpdateNotification = (
  options?: MutationHookOptions<
    UpdateNotificationMutation,
    UpdateNotificationVariables
  >
) => {
  return useMutation(UPDATE_NOTIFICATION, {
    ...options,
    context: { target: GraphqlClientType.APPSYNC_NOTIFICATIONS },
  })
}
